<template>
    <b-modal id="create_user_modal" @ok="createUser">
        <template slot="modal-title">Create a new user</template>
        <form ref="create_user_form">
            <b-form-group
                    label="First name"
                    label-for="first-name"
                    invalid-feedback="First name is required">
                <b-form-input
                        id="first-name"
                        :state="validateFn"
                        v-model="new_user.firstname"
                        autofocus
                        required/>
            </b-form-group>
            <b-form-group
                    label="Last name"
                    label-for="last-name"
                    invalid-feedback="Last name is required">
                <b-form-input
                        id="last-name"
                        :state="validateLn"
                        v-model="new_user.lastname"
                        required/>
            </b-form-group>
            <b-form-group
                    label="Email adres"
                    label-for="email"
                    invalid-feedback="Email is required">
                <b-form-input
                        id="email"
                        type="email"
                        :state="validateEmail"
                        v-model="new_user.email"
                        required/>
            </b-form-group>
            <b-form-group
                    label="User roles"
                    label-for="roles"
                    invalid-feedback="At lease one user role is required">
                <b-form-select
                        id="roles"
                        :state="validateRoles"
                        v-model="new_user.roles"
                        multiple
                        :options="options"
                        required/>
            </b-form-group>
            <b-form-group
                    label="Password"
                    label-for="password">
                <b-form-input
                        id="password"
                        type="password"
                        autocomplete="new-password"
                        :state="validatePassword"
                        v-model="new_user.password"
                        required/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <i v-on="on">requirements</i>
                    </template>
                    <div v-html="password_requirements"></div>
                </v-tooltip>
                <b-form-invalid-feedback :state="validatePassword">
                    Password is invalid. (check requirements)
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Repeat password"
                    label-for="passwordrepeat">
                <b-form-input
                        id="passwordrepeat"
                        type="password"
                        autocomplete="new-password"
                        :state="validatePasswordAgain"
                        v-model="new_user.passwordRepeat"
                        required/>
                <b-form-invalid-feedback :state="validatePasswordAgain">
                    Password are not the same or does not meet the requirements.
                </b-form-invalid-feedback>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import UserRepository from '../../repositories/user.repository';
    import RoleRepository from '../../repositories/role.repository';

    export default {
        props: {
            password_requirements: {
                type: String,
                default: 'password must contain 1 number (0-9) <br /> password must contain 1 uppercase letters <br /> password must contain 1 lowercase letters <br /> password must contain 1 non-alpha numeric number <br /> password is between 8-4096 characters with no space',
            }
        },
        data() {
            let options = [];
            RoleRepository.getAllRoles().then(res => {
                let roles = res.data["roles"];
                roles.forEach(role => {
                    options.push({value: role, text: role})
                });
            });

            return {
                new_user: UserRepository.blankUser(),
                options: options
            }
        },
        methods: {
            checkFields() {
                if (UserRepository.validate.firstName(this.new_user.firstname) === false) return false;
                if (UserRepository.validate.lastName(this.new_user.lastname) === false) return false;
                if (UserRepository.validate.email(this.new_user.email) === false) return false;
                if (UserRepository.validate.roles(this.new_user.roles) === false) return false;
                if (UserRepository.validate.password(this.new_user.password) === false) return false;
                if (UserRepository.validate.passwordRepeat(this.new_user.password, this.new_user.passwordRepeat) === false) return false;
                return true;
            },
            createUser(modal) {
                // If the form is valid try creating a new user.
                if (this.$refs.create_user_form.checkValidity() && this.checkFields()) {
                    this.$emit('change-create-loading');
                    UserRepository.post(this.new_user).then(res => {
                        if (res.status === 201) { // Status 201 means created
                            // Emit the user-created event.
                            this.$emit('change-create-loading');
                            this.$emit('user-created', res.data);
                            // Restore the create user form.
                            this.new_user = UserRepository.blankUser();
                            // Notify the user.
                            this.$bvToast.toast(`User ${res.data.firstname + ' ' + res.data.lastname} successfully created.`, {
                                title: `User created.`,
                                variant: 'success',
                                solid: true
                            });
                        } else {
                            this.$bvToast.toast('Looks like something went wrong while creating a new user.', {
                                title: `User creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    }).catch(error => {
                        this.$emit('change-create-loading');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new user. Check the value\'s of all the fields', {
                                title: `User creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while creating a new user.', {
                                title: `User creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateFn() {
                return UserRepository.validate.firstName(this.new_user.firstname);
            },
            validateLn() {
                return UserRepository.validate.lastName(this.new_user.lastname);
            },
            validateEmail() {
                return UserRepository.validate.email(this.new_user.email);
            },
            validateRoles() {
                return UserRepository.validate.roles(this.new_user.roles);
            },
            validatePassword() {
                return UserRepository.validate.password(this.new_user.password);
            },
            validatePasswordAgain() {
                return UserRepository.validate.passwordRepeat(this.new_user.password, this.new_user.passwordRepeat);
            }
        }
    }
</script>
